(() => {
const CLEAR_THRESHOLD = 0.42;
const SAMPLE_INTERVAL = 140;
const SAMPLE_WIDTH = 48;
const SAMPLE_HEIGHT = 72;
const MAX_CANVAS_DIMENSION = 1400;
const MODULE_KEY = 'axisMundiTrialTwoModule';
const DEBUG_HOTSPOTS = false;
const PLACEHOLDER_MEMORY = 'This memory has not yet been written.';
const EXPLORATION_SCENE_IDS = ['grave', 'dead-tree', 'crossroads', 'mausoleum'];
const HOLLOW_DESTINATION = {
  destination: 'hollow',
  title: 'The Hollow',
  x: 50,
  y: 96,
  direction: 'down',
  requiresAllClues: true,
};
const HOLLOW_TIMING = {
  smokeBuild: 1100,
  smokeDissipate: 1200,
  completionFade: 900,
};
const HOLLOW_STARTS_MUTED = false;

const SCENES = {
  grave: {
    title: 'The Grave',
    renderMode: 'authored',
    treatment: 'grave',
    desktopArt: 'graveDesktop',
    mobileArt: 'graveMobile',
    description: 'A dark graveyard clearing surrounds an open grave.',
    cluesReady: true,
    hotspots: [
      {
        id: 'grave-a',
        title: 'THE MARK',
        content: 'The mark of Axis Mundi is carved into the stone. This grave was meant for the knight.',
        desktop: { x: 50, y: 25 },
        mobile: { x: 50, y: 25 },
      },
      {
        id: 'grave-b',
        title: 'DISTURBED EARTH',
        content: 'The earth has been violently disturbed. There is evidence of a struggle here.',
        desktop: { x: 48, y: 53 },
        mobile: { x: 48, y: 53 },
      },
      {
        id: 'grave-c',
        title: 'TRACKS',
        content: 'Tracks pass beside the grave and disappear into the dark.',
        desktop: { x: 81, y: 92 },
        mobile: { x: 81, y: 92 },
      },
    ],
    exits: [
      { destination: 'mausoleum', x: 23, y: 84, direction: 'left' },
      { destination: 'dead-tree', x: 50, y: 88, direction: 'forward' },
      { destination: 'crossroads', x: 77, y: 84, direction: 'right' },
      HOLLOW_DESTINATION,
    ],
  },
  mausoleum: {
    title: 'The Mausoleum',
    renderMode: 'authored',
    treatment: 'mausoleum',
    desktopArt: 'mausoleumDesktop',
    mobileArt: 'mausoleumMobile',
    description: 'The mausoleum fills the near view. Its doorway lies ahead, with a weathered gravestone to the left and a dead tree to the right.',
    cluesReady: true,
    hotspots: [
      {
        id: 'mausoleum-a',
        title: 'THE GATE',
        content: 'The gate hangs open. The hinges are old, but the ground beneath them has been disturbed recently.',
        desktop: { x: 42, y: 66 },
        mobile: { x: 42, y: 66 },
      },
      {
        id: 'mausoleum-b',
        title: 'THE WATCHER',
        content: 'The stone watcher has guarded this place longer than any name carved within. Its gaze remains fixed on the path below.',
        desktop: { x: 69, y: 28 },
        mobile: { x: 69, y: 28 },
      },
      {
        id: 'mausoleum-c',
        title: 'THE CRACKS',
        content: 'Deep fractures split the stone from within. Whatever caused them did not come from the weather.',
        desktop: { x: 68, y: 61 },
        mobile: { x: 68, y: 61 },
      },
    ],
    exits: [
      { destination: 'grave', x: 24, y: 85, direction: 'left' },
      { destination: 'dead-tree', x: 50, y: 89, direction: 'forward' },
      { destination: 'crossroads', x: 76, y: 85, direction: 'right' },
      HOLLOW_DESTINATION,
    ],
  },
  'dead-tree': {
    title: 'The Dead Tree',
    renderMode: 'authored',
    treatment: 'dead-tree',
    desktopArt: 'deadTreeDesktop',
    mobileArt: 'deadTreeMobile',
    description: 'A dead tree rises from a dark corner of the graveyard.',
    cluesReady: true,
    hotspots: [
      {
        id: 'dead-tree-a',
        title: 'THE HOLLOW',
        content: 'The trunk has rotted open from within. Something has made use of the shelter, but whatever was here is gone now.',
        desktop: { x: 50, y: 46 },
        mobile: { x: 50, y: 46 },
      },
      {
        id: 'dead-tree-b',
        title: 'THE MARK',
        content: 'A familiar mark has been cut into the bark. Time has weathered the edges, but the symbol remains.',
        desktop: { x: 51, y: 62 },
        mobile: { x: 51, y: 62 },
      },
      {
        id: 'dead-tree-c',
        title: 'THE CLOTH',
        content: 'A torn scrap is caught beneath the roots. The fabric is weathered, but it did not grow here.',
        desktop: { x: 44, y: 82 },
        mobile: { x: 44, y: 82 },
      },
    ],
    exits: [
      { destination: 'grave', x: 22, y: 85, direction: 'left' },
      { destination: 'mausoleum', x: 50, y: 89, direction: 'forward' },
      { destination: 'crossroads', x: 78, y: 85, direction: 'right' },
      HOLLOW_DESTINATION,
    ],
  },
  crossroads: {
    title: 'The Crossroads',
    renderMode: 'authored',
    treatment: 'crossroads',
    desktopArt: 'crossroadsDesktop',
    mobileArt: 'crossroadsMobile',
    description: 'Several indistinct graveyard paths meet in the dark.',
    cluesReady: true,
    hotspots: [
      {
        id: 'crossroads-a',
        title: 'BEFORE',
        content: 'Before the blood. Before the curse.\nWouldst thou choose differently?',
        desktop: { x: 50, y: 20 },
        mobile: { x: 50, y: 20 },
      },
      {
        id: 'crossroads-b',
        title: 'ATONE',
        content: 'No penance returns what was taken.',
        desktop: { x: 50, y: 32 },
        mobile: { x: 50, y: 32 },
      },
      {
        id: 'crossroads-c',
        title: 'END',
        content: 'Thou hast tried this road before.\nIt would not have thee.',
        desktop: { x: 50, y: 47 },
        mobile: { x: 50, y: 47 },
      },
    ],
    exits: [
      { destination: 'grave', x: 20, y: 84, direction: 'left' },
      { destination: 'mausoleum', x: 50, y: 89, direction: 'forward' },
      { destination: 'dead-tree', x: 80, y: 84, direction: 'right' },
      HOLLOW_DESTINATION,
    ],
  },
};

const CLUE_IDS = new Set(EXPLORATION_SCENE_IDS.flatMap((sceneId) => (
  SCENES[sceneId].cluesReady === false ? [] : SCENES[sceneId].hotspots.map((hotspot) => hotspot.id)
)));
const TOTAL_CLUES = CLUE_IDS.size;

if (window[MODULE_KEY]) {
  window[MODULE_KEY].init(document);
  return;
}

class AxisMundiTrialTwo {
  constructor(root) {
    this.root = root;
    this.canvas = root.querySelector('[data-axis-smoke-canvas]');
    this.knightStage = root.querySelector('[data-axis-knight-stage]');
    this.opening = root.querySelector('[data-axis-opening]');
    this.fallbackButton = root.querySelector('[data-axis-clear-fallback]');
    this.status = root.querySelector('[data-axis-trial-two-status]');
    this.descentSmoke = root.querySelector('[data-axis-descent-smoke]');
    this.ambientVideos = Array.from(root.querySelectorAll('[data-axis-ambient-video]'));
    this.graveyard = root.querySelector('[data-axis-graveyard]');
    this.sceneStage = root.querySelector('[data-axis-scene-stage]');
    this.sceneVisual = root.querySelector('[data-axis-scene-visual]');
    this.sceneHotspots = root.querySelector('[data-axis-scene-hotspots]');
    this.sceneSmoke = root.querySelector('[data-axis-scene-smoke]');
    this.sceneDescription = root.querySelector('[data-axis-scene-description]');
    this.clueProgress = root.querySelector('[data-axis-clue-progress]');
    this.clueCount = root.querySelector('[data-axis-clue-count]');
    this.clueTotal = root.querySelector('[data-axis-clue-total]');
    this.clueReveal = root.querySelector('[data-axis-clue-reveal]');
    this.finale = root.querySelector('[data-axis-hollow-finale]');
    this.finaleVideo = root.querySelector('[data-axis-hollow-video]');
    this.finaleStatus = root.querySelector('[data-axis-hollow-status]');
    this.finaleRecovery = root.querySelector('[data-axis-hollow-recovery]');
    this.view = root.closest('[data-axis-view="chapter-2"]');
    this.openButton = root.closest('[data-axis-world]')?.querySelector('[data-axis-open-chapter="chapter-2"]');
    this.backButton = this.view?.querySelector('[data-axis-back-to-chapters]');
    this.context = this.canvas?.getContext('2d', { willReadFrequently: true }) || null;
    this.sampleCanvas = document.createElement('canvas');
    this.sampleCanvas.width = SAMPLE_WIDTH;
    this.sampleCanvas.height = SAMPLE_HEIGHT;
    this.sampleContext = this.sampleCanvas.getContext('2d', { willReadFrequently: true });
    this.abortController = new AbortController();
    this.resizeObserver = null;
    this.pendingWaits = new Set();
    this.sampleTimer = null;
    this.activePointerId = null;
    this.lastPoint = null;
    this.canvasScale = 1;
    this.initialOpaqueSamples = 0;
    this.phase = 'reveal';
    this.currentSceneId = null;
    this.investigatedHotspots = new Set();
    this.hollowUnlocked = false;
    this.hollowRevealPending = false;
    this.finaleLoaded = false;
    this.finalePlayed = false;
    this.finaleEnded = false;
    this.finaleFailed = false;
    this.narrationStarted = false;
    this.completionDispatched = false;
    this.preloadedBackgrounds = new Set();
    this.lastOverlayTrigger = null;
    this.navigationLocked = false;
    this.destroyed = false;
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!this.canvas || !this.knightStage || !this.context || !this.sampleContext) return;

    this.createArtworkPlane();
    if (this.clueTotal) this.clueTotal.textContent = String(TOTAL_CLUES);
    this.bindEvents();
    this.createInvestigationOverlay();
    this.configureMedia();
    this.observeSize();
    this.resizeCanvas();
  }

  configureMedia() {
    [this.descentSmoke, ...this.ambientVideos].forEach((video) => {
      if (video) video.muted = true;
    });

    if (this.prefersReducedMotion) {
      this.ambientVideos.forEach((video) => video.pause());
    }
  }

  bindEvents() {
    const signal = this.abortController.signal;

    this.canvas.addEventListener('pointerdown', (event) => this.handlePointerDown(event), { signal });
    this.canvas.addEventListener('pointermove', (event) => this.handlePointerMove(event), { signal });
    this.canvas.addEventListener('pointerup', (event) => this.handlePointerEnd(event), { signal });
    this.canvas.addEventListener('pointercancel', (event) => this.handlePointerEnd(event), { signal });
    this.fallbackButton?.addEventListener('click', () => this.clearWithFallback(), { signal });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.investigationOverlay && !this.investigationOverlay.hidden) {
        this.closeInvestigation();
      }
    }, { signal });
    this.openButton?.addEventListener('click', () => {
      window.requestAnimationFrame(() => this.fallbackButton?.focus());
    }, { signal });
    this.backButton?.addEventListener('click', () => {
      window.requestAnimationFrame(() => this.openButton?.focus());
    }, { signal });
    this.root.closest('[data-axis-world]')?.addEventListener('axis:trial-two-progress-state', (event) => {
      this.restoreProgress(event.detail?.investigatedHotspots);
    }, { signal });
    this.finaleVideo?.addEventListener('loadeddata', () => {
      this.finaleLoaded = true;
    }, { signal });
    this.finaleVideo?.addEventListener('playing', () => {
      this.finalePlayed = true;
    }, { signal });
    this.finaleVideo?.addEventListener('ended', () => {
      this.finaleEnded = true;
      this.completeHollowFinale();
    }, { signal });
    this.finaleVideo?.addEventListener('error', () => this.handleFinaleFailure(), { signal });
    this.finaleRecovery?.addEventListener('click', () => this.recoverFromFinale(), { signal });
  }

  observeSize() {
    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => {
        if (this.phase === 'reveal' && this.activePointerId === null) this.resizeCanvas();
      });
      this.resizeObserver.observe(this.canvas);
      return;
    }

    window.addEventListener('resize', () => this.resizeCanvas(), { signal: this.abortController.signal });
  }

  resizeCanvas() {
    if (this.destroyed || this.phase !== 'reveal') return;

    const rect = this.canvas.getBoundingClientRect();
    if (rect.width < 1 || rect.height < 1) return;

    const requestedScale = Math.min(window.devicePixelRatio || 1, 2);
    const cappedScale = Math.min(
      requestedScale,
      MAX_CANVAS_DIMENSION / rect.width,
      MAX_CANVAS_DIMENSION / rect.height,
    );
    const width = Math.max(1, Math.round(rect.width * cappedScale));
    const height = Math.max(1, Math.round(rect.height * cappedScale));
    if (this.canvas.width === width && this.canvas.height === height) return;

    this.canvas.width = width;
    this.canvas.height = height;
    this.canvasScale = cappedScale;
    this.drawSmoke();
  }

  drawSmoke() {
    const { width, height } = this.canvas;
    const context = this.context;
    let seed = 0x2f6e2b1;
    const random = () => {
      seed = ((seed * 1664525) + 1013904223) >>> 0;
      return seed / 4294967296;
    };

    context.globalCompositeOperation = 'source-over';
    context.clearRect(0, 0, width, height);

    const drawSmokeMass = (x, y, radiusX, radiusY, opacity, tones) => {
      const pointCount = 9 + Math.floor(random() * 5);
      const points = [];

      for (let index = 0; index < pointCount; index += 1) {
        const angle = (index / pointCount) * Math.PI * 2;
        const radius = 0.7 + (random() * 0.3);
        points.push({
          x: Math.cos(angle) * radius,
          y: Math.sin(angle) * radius,
        });
      }

      context.save();
      context.translate(x, y);
      context.rotate((random() - 0.5) * 1.6);
      context.scale(radiusX, radiusY);
      const gradient = context.createRadialGradient(0, 0, 0, 0, 0, 1);
      const edgeStop = 0.68 + (random() * 0.16);
      gradient.addColorStop(0, `rgba(${tones[0]}, ${opacity})`);
      gradient.addColorStop(0.4, `rgba(${tones[1]}, ${opacity * 0.82})`);
      gradient.addColorStop(edgeStop, `rgba(${tones[2]}, ${opacity * 0.34})`);
      gradient.addColorStop(1, `rgba(${tones[2]}, 0)`);
      context.fillStyle = gradient;
      context.beginPath();
      const firstMidpoint = {
        x: (points[pointCount - 1].x + points[0].x) / 2,
        y: (points[pointCount - 1].y + points[0].y) / 2,
      };
      context.moveTo(firstMidpoint.x, firstMidpoint.y);
      points.forEach((point, index) => {
        const nextPoint = points[(index + 1) % pointCount];
        context.quadraticCurveTo(
          point.x,
          point.y,
          (point.x + nextPoint.x) / 2,
          (point.y + nextPoint.y) / 2,
        );
      });
      context.closePath();
      context.fill();
      context.restore();
    };

    for (let index = 0; index < 30; index += 1) {
      drawSmokeMass(
        width * (0.08 + (((random() + random()) / 2) * 0.84)),
        height * (0.1 + (((random() + random()) / 2) * 0.8)),
        width * (0.11 + (random() * 0.12)),
        height * (0.09 + (random() * 0.1)),
        0.18 + (random() * 0.12),
        ['26, 34, 34', '52, 62, 60', '84, 96, 91'],
      );
    }

    for (let index = 0; index < 24; index += 1) {
      drawSmokeMass(
        width * (0.16 + (((random() + random()) / 2) * 0.68)),
        height * (0.16 + (((random() + random()) / 2) * 0.68)),
        width * (0.055 + (random() * 0.09)),
        height * (0.055 + (random() * 0.09)),
        0.24 + (random() * 0.2),
        ['9, 14, 14', '28, 36, 35', '68, 80, 76'],
      );
    }

    context.save();
    context.globalCompositeOperation = 'destination-out';
    for (let index = 0; index < 8; index += 1) {
      const x = width * (0.08 + (random() * 0.84));
      const y = height * (0.14 + (random() * 0.72));
      const radiusX = width * (0.045 + (random() * 0.07));
      const radiusY = height * (0.045 + (random() * 0.08));
      const opacity = 0.28 + (random() * 0.24);

      context.save();
      context.translate(x, y);
      context.rotate((random() - 0.5) * 1.8);
      context.scale(radiusX, radiusY);
      const gradient = context.createRadialGradient(0, 0, 0, 0, 0, 1);
      gradient.addColorStop(0, `rgba(0, 0, 0, ${opacity})`);
      gradient.addColorStop(0.58, `rgba(0, 0, 0, ${opacity * 0.5})`);
      gradient.addColorStop(1, 'rgba(0, 0, 0, 0)');
      context.fillStyle = gradient;
      context.beginPath();
      context.arc(0, 0, 1, 0, Math.PI * 2);
      context.fill();
      context.restore();
    }
    context.restore();

    context.save();
    context.globalCompositeOperation = 'destination-in';
    context.translate(width / 2, height / 2);
    context.scale(width / 2, height / 2);
    const edgeMask = context.createRadialGradient(0, 0, 0, 0, 0, 1);
    edgeMask.addColorStop(0, 'rgba(0, 0, 0, 1)');
    edgeMask.addColorStop(0.7, 'rgba(0, 0, 0, 1)');
    edgeMask.addColorStop(0.82, 'rgba(0, 0, 0, 0.65)');
    edgeMask.addColorStop(0.9, 'rgba(0, 0, 0, 0.18)');
    edgeMask.addColorStop(1, 'rgba(0, 0, 0, 0)');
    context.fillStyle = edgeMask;
    context.beginPath();
    context.arc(0, 0, 1, 0, Math.PI * 2);
    context.fill();
    context.restore();

    this.initialOpaqueSamples = this.countOpaqueSamples();
  }

  handlePointerDown(event) {
    if (this.phase !== 'reveal' || this.activePointerId !== null) return;
    if (this.canvas.width < 2 || this.canvas.height < 2) this.resizeCanvas();

    event.preventDefault();
    this.activePointerId = event.pointerId;
    this.canvas.setPointerCapture(event.pointerId);
    this.lastPoint = this.getCanvasPoint(event);
    this.eraseStroke(this.lastPoint, this.lastPoint);
    this.scheduleSample();
  }

  handlePointerMove(event) {
    if (event.pointerId !== this.activePointerId || this.phase !== 'reveal') return;

    event.preventDefault();
    const point = this.getCanvasPoint(event);
    this.eraseStroke(this.lastPoint, point);
    this.lastPoint = point;
    this.scheduleSample();
  }

  handlePointerEnd(event) {
    if (event.pointerId !== this.activePointerId) return;

    event.preventDefault();
    if (this.canvas.hasPointerCapture(event.pointerId)) this.canvas.releasePointerCapture(event.pointerId);
    this.activePointerId = null;
    this.lastPoint = null;
    this.scheduleSample(0);
  }

  getCanvasPoint(event) {
    const rect = this.canvas.getBoundingClientRect();
    return {
      x: (event.clientX - rect.left) * (this.canvas.width / rect.width),
      y: (event.clientY - rect.top) * (this.canvas.height / rect.height),
    };
  }

  eraseStroke(from, to) {
    if (!from || !to) return;

    const context = this.context;
    const radius = this.getClearRadius();
    const distance = Math.hypot(to.x - from.x, to.y - from.y);
    const spacing = Math.max(1, radius * 0.22);
    const steps = Math.ceil(distance / spacing);

    context.save();
    context.globalCompositeOperation = 'destination-out';
    for (let index = 0; index <= steps; index += 1) {
      const progress = steps === 0 ? 0 : index / steps;
      this.eraseSmokeAt({
        x: from.x + ((to.x - from.x) * progress),
        y: from.y + ((to.y - from.y) * progress),
      }, radius);
    }
    context.restore();
  }

  getClearRadius() {
    const rect = this.canvas.getBoundingClientRect();
    const diameter = window.matchMedia('(max-width: 749px)').matches
      ? Math.max(100, Math.min(160, rect.width * 0.36))
      : Math.max(140, Math.min(220, rect.width * 0.2));
    return (diameter / 2) * this.canvasScale;
  }

  eraseSmokeAt(point, radius) {
    const gradient = this.context.createRadialGradient(point.x, point.y, 0, point.x, point.y, radius);
    gradient.addColorStop(0, 'rgba(0, 0, 0, 1)');
    gradient.addColorStop(0.42, 'rgba(0, 0, 0, 0.9)');
    gradient.addColorStop(0.72, 'rgba(0, 0, 0, 0.42)');
    gradient.addColorStop(1, 'rgba(0, 0, 0, 0)');
    this.context.fillStyle = gradient;
    this.context.beginPath();
    this.context.arc(point.x, point.y, radius, 0, Math.PI * 2);
    this.context.fill();
  }

  scheduleSample(delay = SAMPLE_INTERVAL) {
    if (this.sampleTimer !== null || this.phase !== 'reveal') return;

    this.sampleTimer = window.setTimeout(() => {
      this.sampleTimer = null;
      this.measureClearedArea();
    }, delay);
  }

  measureClearedArea() {
    if (this.phase !== 'reveal') return;

    const opaqueSamples = this.countOpaqueSamples();
    const clearedRatio = this.initialOpaqueSamples > 0
      ? Math.max(0, Math.min(1, 1 - (opaqueSamples / this.initialOpaqueSamples)))
      : 0;
    if (this.status) this.status.textContent = `${Math.round(clearedRatio * 100)}% of the smoke cleared.`;
    if (clearedRatio >= CLEAR_THRESHOLD) this.beginDescent();
  }

  countOpaqueSamples() {
    this.sampleContext.clearRect(0, 0, SAMPLE_WIDTH, SAMPLE_HEIGHT);
    this.sampleContext.drawImage(this.canvas, 0, 0, SAMPLE_WIDTH, SAMPLE_HEIGHT);
    const pixels = this.sampleContext.getImageData(0, 0, SAMPLE_WIDTH, SAMPLE_HEIGHT).data;
    let opaquePixels = 0;

    for (let index = 3; index < pixels.length; index += 4) {
      if (pixels[index] >= 32) opaquePixels += 1;
    }

    return opaquePixels;
  }

  clearWithFallback() {
    if (this.phase !== 'reveal') return;

    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    if (this.status) this.status.textContent = 'The Knight is revealed.';
    this.beginDescent();
  }

  setPhase(phase) {
    this.phase = phase;
    this.root.dataset.phase = phase;
  }

  async beginDescent() {
    if (this.phase !== 'reveal') return;

    this.canvas.style.pointerEvents = 'none';
    if (this.fallbackButton) this.fallbackButton.disabled = true;
    if (this.status) this.status.textContent = 'The Knight is revealed.';

    this.setPhase('revealed');
    await this.delay(this.prefersReducedMotion ? 180 : 560);
    if (this.destroyed) return;

    if (this.status) this.status.textContent = 'Smoke closes around the Knight.';
    this.startTransitionSmoke();
    this.setPhase('smoke');
    await this.nextFrame();
    await this.waitForTransition(this.descentSmoke, 'opacity', this.prefersReducedMotion ? 180 : 760);
    if (this.destroyed) return;

    this.setPhase('descent');
    this.renderScene('grave', false);
    this.graveyard.hidden = false;
    await this.nextFrame();
    this.setPhase('exploration');
    await this.waitForTransition(this.descentSmoke, 'opacity', this.prefersReducedMotion ? 160 : 780);
    if (this.destroyed) return;

    this.opening.hidden = true;
    this.descentSmoke?.pause();
    this.focusFirstHotspot();
  }

  startTransitionSmoke() {
    if (!this.descentSmoke) return;

    this.descentSmoke.pause();
    if (this.descentSmoke.readyState > 0) this.descentSmoke.currentTime = 0;
    if (!this.prefersReducedMotion) {
      const playback = this.descentSmoke.play();
      playback?.catch(() => {});
    }
  }

  createArtworkPlane() {
    if (!this.sceneVisual || !this.sceneStage || !this.sceneHotspots) return;

    const artworkPlane = document.createElement('div');
    artworkPlane.className = 'axis-trial-two__artwork-plane axis-trial-two__artwork-coordinate-plane';
    artworkPlane.setAttribute('aria-hidden', 'true');
    const artworkSurface = document.createElement('div');
    artworkSurface.className = 'axis-trial-two__artwork-surface';
    artworkPlane.appendChild(artworkSurface);
    this.sceneVisual.prepend(artworkPlane);

    const artworkHotspots = document.createElement('div');
    artworkHotspots.className = 'axis-trial-two__artwork-hotspots axis-trial-two__artwork-coordinate-plane';
    this.sceneStage.insertBefore(artworkHotspots, this.sceneHotspots);

    this.artworkPlane = artworkPlane;
    this.artworkSurface = artworkSurface;
    this.artworkHotspots = artworkHotspots;
  }

  renderScene(sceneId, focusHotspot = true) {
    const scene = SCENES[sceneId];
    if (!scene || !this.sceneVisual || !this.sceneHotspots || !this.artworkSurface || !this.artworkHotspots) return;

    this.currentSceneId = sceneId;
    this.root.scrollTop = 0;
    this.sceneStage.scrollTop = 0;
    this.sceneStage.scrollLeft = 0;
    this.root.dataset.scene = sceneId;
    this.root.dataset.sceneMode = scene.renderMode;
    const desktopArt = scene.desktopArt ? this.root.dataset[scene.desktopArt] : '';
    const mobileArt = scene.mobileArt ? this.root.dataset[scene.mobileArt] : '';
    const hasAuthoredArt = Boolean(desktopArt || mobileArt);
    this.root.dataset.artworkState = hasAuthoredArt ? 'final' : 'placeholder';
    this.sceneVisual.dataset.treatment = scene.treatment;
    this.artworkPlane.hidden = scene.renderArtwork === false;
    this.artworkHotspots.hidden = scene.renderArtwork === false;
    this.artworkSurface.style.setProperty('--axis-scene-background-desktop', desktopArt ? `url("${desktopArt}")` : 'none');
    this.artworkSurface.style.setProperty('--axis-scene-background-mobile', mobileArt ? `url("${mobileArt}")` : (desktopArt ? `url("${desktopArt}")` : 'none'));
    this.artworkSurface.classList.toggle('is-placeholder', !hasAuthoredArt && scene.renderMode === 'authored');
    this.sceneVisual.setAttribute('aria-label', scene.description);
    if (this.sceneDescription) this.sceneDescription.textContent = scene.description;
    this.sceneHotspots.replaceChildren();
    this.artworkHotspots.replaceChildren();

    if (DEBUG_HOTSPOTS) {
      const debugLabel = document.createElement('p');
      debugLabel.className = 'axis-trial-two__debug-scene';
      debugLabel.textContent = `${scene.title} · DEBUG HOTSPOTS`;
      this.sceneHotspots.appendChild(debugLabel);

    }

    const renderedHotspots = scene.cluesReady === false ? [] : scene.hotspots;
    renderedHotspots.forEach((hotspot) => {
      const desktopPosition = hotspot.desktop || hotspot;
      const mobilePosition = hotspot.mobile || desktopPosition;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'axis-trial-two__investigation-hotspot';
      button.dataset.hotspotId = hotspot.id;
      button.setAttribute('aria-label', `Investigate ${hotspot.title}`);
      button.style.setProperty('--axis-hotspot-x-desktop', `${desktopPosition.x}%`);
      button.style.setProperty('--axis-hotspot-y-desktop', `${desktopPosition.y}%`);
      button.style.setProperty('--axis-hotspot-x-mobile', `${mobilePosition.x}%`);
      button.style.setProperty('--axis-hotspot-y-mobile', `${mobilePosition.y}%`);
      button.classList.toggle('is-investigated', this.investigatedHotspots.has(hotspot.id));
      button.disabled = this.navigationLocked;
      const marker = document.createElement('span');
      marker.className = 'axis-trial-two__investigation-marker';
      marker.setAttribute('aria-hidden', 'true');
      const label = document.createElement('span');
      label.className = DEBUG_HOTSPOTS ? 'axis-trial-two__debug-label' : 'visually-hidden';
      label.textContent = DEBUG_HOTSPOTS
        ? `${hotspot.title} · D ${desktopPosition.x}%, ${desktopPosition.y}% · M ${mobilePosition.x}%, ${mobilePosition.y}%`
        : hotspot.title;
      button.append(marker, label);
      button.addEventListener('click', () => this.openInvestigation(hotspot, button), { signal: this.abortController.signal });
      const hotspotHost = scene.renderMode === 'authored' ? this.artworkHotspots : this.sceneHotspots;
      hotspotHost.appendChild(button);
    });

    this.renderNavigation(scene);

    this.preloadConnectedScenes(scene);

    if (focusHotspot) this.focusFirstHotspot();
  }

  renderNavigation(scene) {
    this.sceneHotspots.querySelectorAll('.axis-trial-two__scene-exit').forEach((exit) => exit.remove());

    scene.exits.filter((exit) => !exit.requiresAllClues || this.hollowUnlocked).forEach((exit) => {
      const destination = SCENES[exit.destination];
      const destinationTitle = exit.title || destination?.title;
      if (!destinationTitle) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'axis-trial-two__scene-exit';
      if (exit.requiresAllClues) {
        button.classList.add('is-revealed-destination');
        button.classList.toggle('is-newly-revealed', this.hollowRevealPending);
      }
      button.dataset.destination = exit.destination;
      button.dataset.direction = exit.direction;
      button.setAttribute('aria-label', `Travel to ${destinationTitle}`);
      button.style.setProperty('--axis-exit-x', `${exit.x}%`);
      button.style.setProperty('--axis-exit-y', `${exit.y}%`);
      button.disabled = this.navigationLocked;
      const marker = document.createElement('span');
      marker.className = 'axis-trial-two__exit-marker';
      marker.setAttribute('aria-hidden', 'true');
      const label = document.createElement('span');
      label.className = 'axis-trial-two__exit-label';
      label.textContent = destinationTitle;
      button.append(marker, label);
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.navigate(exit);
      }, { signal: this.abortController.signal });
      this.sceneHotspots.appendChild(button);
    });
    this.hollowRevealPending = false;
  }

  createInvestigationOverlay() {
    const overlay = document.createElement('div');
    overlay.className = 'axis-trial-two__investigation-overlay';
    overlay.hidden = true;
    overlay.innerHTML = '<div class="axis-trial-two__investigation-panel" role="dialog" aria-modal="true" aria-labelledby="AxisTrialTwoInvestigationTitle"><h3 id="AxisTrialTwoInvestigationTitle" data-axis-investigation-title></h3><p data-axis-investigation-copy></p><button type="button" data-axis-investigation-close>Return to the graveyard</button></div>';
    this.root.appendChild(overlay);
    this.investigationOverlay = overlay;
    this.investigationTitle = overlay.querySelector('[data-axis-investigation-title]');
    this.investigationCopy = overlay.querySelector('[data-axis-investigation-copy]');
    this.investigationClose = overlay.querySelector('[data-axis-investigation-close]');
    this.investigationClose.addEventListener('click', () => this.closeInvestigation(), { signal: this.abortController.signal });
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) this.closeInvestigation();
    }, { signal: this.abortController.signal });
  }

  openInvestigation(hotspot, trigger) {
    const isNewClue = CLUE_IDS.has(hotspot.id) && !this.investigatedHotspots.has(hotspot.id);
    if (CLUE_IDS.has(hotspot.id)) this.investigatedHotspots.add(hotspot.id);
    trigger.classList.add('is-investigated', 'is-selected');
    window.setTimeout(() => trigger.classList.remove('is-selected'), 360);
    this.lastOverlayTrigger = trigger;
    this.investigationTitle.textContent = hotspot.title;
    this.investigationCopy.textContent = hotspot.content || PLACEHOLDER_MEMORY;
    this.investigationOverlay.hidden = false;
    this.investigationClose.focus();
    if (isNewClue) {
      this.persistProgress();
      this.updateClueProgress();
    }
  }

  updateClueProgress() {
    const discoveredClues = Array.from(this.investigatedHotspots).filter((hotspotId) => CLUE_IDS.has(hotspotId)).length;
    if (this.clueCount) this.clueCount.textContent = String(discoveredClues);
    if (discoveredClues !== TOTAL_CLUES || this.hollowUnlocked) return;

    this.hollowUnlocked = true;
    this.hollowRevealPending = true;
    this.root.dataset.hollowUnlocked = 'true';
    this.clueProgress?.classList.add('is-complete');
    if (this.clueReveal) this.clueReveal.hidden = false;
    const scene = SCENES[this.currentSceneId];
    if (scene && EXPLORATION_SCENE_IDS.includes(this.currentSceneId)) this.renderNavigation(scene);
  }

  restoreProgress(savedHotspots) {
    if (!Array.isArray(savedHotspots)) return;

    savedHotspots.forEach((hotspotId) => {
      if (CLUE_IDS.has(hotspotId)) this.investigatedHotspots.add(hotspotId);
    });
    this.updateClueProgress();
    this.hollowRevealPending = false;
    const scene = SCENES[this.currentSceneId];
    if (scene) this.renderScene(this.currentSceneId, false);
  }

  persistProgress() {
    this.root.dispatchEvent(new CustomEvent('axis:trial-two-progress', {
      bubbles: true,
      detail: {
        investigatedHotspots: Array.from(this.investigatedHotspots).filter((hotspotId) => CLUE_IDS.has(hotspotId)),
      },
    }));
  }

  closeInvestigation() {
    if (!this.investigationOverlay || this.investigationOverlay.hidden) return;
    this.investigationOverlay.hidden = true;
    this.lastOverlayTrigger?.focus({ preventScroll: true });
  }

  preloadConnectedScenes(scene) {
    window.setTimeout(() => {
      scene.exits.forEach(({ destination }) => {
        const destinationScene = SCENES[destination];
        if (!destinationScene || destinationScene.renderMode !== 'authored') return;

        [destinationScene.desktopArt, destinationScene.mobileArt].forEach((artKey) => {
          const artwork = artKey ? this.root.dataset[artKey] : '';
          if (!artwork || this.preloadedBackgrounds.has(artwork)) return;
          const image = new Image();
          image.src = artwork;
          this.preloadedBackgrounds.add(artwork);
        });
      });
    }, 250);
  }

  async navigate(hotspot) {
    if (
      this.navigationLocked
      || (hotspot.destination !== 'hollow' && !SCENES[hotspot.destination])
      || (hotspot.destination === 'hollow' && !this.hollowUnlocked)
      || this.phase !== 'exploration'
    ) return;

    if (hotspot.destination === 'hollow') {
      this.beginHollowFinale();
      return;
    }

    this.navigationLocked = true;
    this.setHotspotsDisabled(true);
    this.sceneStage.dataset.transitionDirection = hotspot.direction || 'forward';
    this.sceneStage.classList.remove('is-revealing');
    this.sceneStage.classList.add('is-moving');

    await this.nextFrame();
    await this.waitForTransition(this.sceneSmoke, 'opacity', this.prefersReducedMotion ? 140 : 620);
    if (this.destroyed) return;

    this.renderScene(hotspot.destination, false);
    await this.nextFrame();
    this.sceneStage.classList.remove('is-moving');
    this.sceneStage.classList.add('is-revealing');

    await this.waitForTransition(this.sceneSmoke, 'opacity', this.prefersReducedMotion ? 140 : 620);
    if (this.destroyed) return;

    this.sceneStage.classList.remove('is-revealing');
    this.sceneStage.removeAttribute('data-transition-direction');
    this.navigationLocked = false;
    this.setHotspotsDisabled(false);
    this.focusFirstHotspot();
  }

  async beginHollowFinale() {
    if (!this.finale || !this.finaleVideo || this.navigationLocked || !this.hollowUnlocked) return;

    this.navigationLocked = true;
    this.setHotspotsDisabled(true);
    this.finaleFailed = false;
    this.finaleLoaded = this.finaleVideo.readyState >= 2;
    this.finalePlayed = false;
    this.finaleEnded = false;
    this.narrationStarted = false;
    this.completionDispatched = false;
    this.finale.hidden = false;
    this.finaleRecovery.hidden = true;
    if (this.finaleStatus) this.finaleStatus.textContent = 'Entering The Hollow.';
    this.finaleVideo.muted = HOLLOW_STARTS_MUTED;
    if (this.finaleVideo.readyState > 0) this.finaleVideo.currentTime = 0;
    this.setPhase('hollow-transition');
    this.sceneStage?.classList.add('is-entering-hollow');
    this.startTransitionSmoke();

    const playback = this.finaleVideo.play();
    playback?.catch(() => {
      if (this.destroyed || this.finaleFailed) return;

      this.finaleVideo.muted = true;
      const mutedPlayback = this.finaleVideo.play();
      mutedPlayback?.catch(() => this.handleFinaleFailure());
    });

    await this.delay(this.prefersReducedMotion ? 180 : HOLLOW_TIMING.smokeBuild);
    if (this.destroyed || this.finaleFailed) return;

    this.setPhase('hollow-video');
    this.sceneStage?.classList.remove('is-entering-hollow');
    if (this.finaleEnded) {
      this.completeHollowFinale();
      return;
    }
    await this.delay(this.prefersReducedMotion ? 180 : HOLLOW_TIMING.smokeDissipate);
    if (this.destroyed || this.finaleFailed) return;

    this.descentSmoke?.pause();
    if (this.finaleStatus) this.finaleStatus.textContent = 'The Hollow finale is playing.';
  }

  handleFinaleFailure() {
    if (this.phase !== 'hollow-transition' && this.phase !== 'hollow-video') return;

    this.finaleFailed = true;
    this.finaleVideo?.pause();
    this.setPhase('hollow-video-failed');
    this.sceneStage?.classList.remove('is-entering-hollow');
    if (this.finaleStatus) this.finaleStatus.textContent = 'The Hollow finale video is not available yet.';
    if (this.finaleRecovery) {
      this.finaleRecovery.hidden = false;
      this.finaleRecovery.focus();
    }
  }

  recoverFromFinale() {
    this.finaleVideo?.pause();
    if (this.finale) this.finale.hidden = true;
    if (this.finaleRecovery) this.finaleRecovery.hidden = true;
    this.descentSmoke?.pause();
    this.sceneStage?.classList.remove('is-entering-hollow');
    this.setPhase('exploration');
    this.navigationLocked = false;
    this.setHotspotsDisabled(false);
    this.focusFirstHotspot();
  }

  async completeHollowFinale() {
    if (
      this.phase !== 'hollow-video'
      || !this.finaleLoaded
      || !this.finalePlayed
      || this.finaleFailed
      || this.narrationStarted
    ) return;

    const world = this.root.closest('[data-axis-world]')?.axisMundiWorld;
    if (!world) return;

    this.narrationStarted = true;
    this.setPhase('hollow-narration');
    if (this.finaleStatus) this.finaleStatus.textContent = 'Audi Sonum narration is playing.';
    world.openTrialTwoNarration(() => this.finishHollowFinale());
  }

  async finishHollowFinale() {
    if (this.phase !== 'hollow-narration' || this.completionDispatched) return;

    this.setPhase('complete');
    if (this.finaleStatus) this.finaleStatus.textContent = 'Trial II complete.';
    await this.delay(this.prefersReducedMotion ? 180 : HOLLOW_TIMING.completionFade);
    if (this.destroyed || this.completionDispatched) return;
    this.completionDispatched = true;
    this.root.dispatchEvent(new CustomEvent('axis:chapter-complete', {
      bubbles: true,
      detail: { chapter: 'chapter-2' },
    }));
  }

  setHotspotsDisabled(disabled) {
    this.sceneStage?.querySelectorAll('.axis-trial-two__scene-hotspots button, .axis-trial-two__artwork-hotspots button').forEach((button) => {
      button.disabled = disabled;
    });
  }

  focusFirstHotspot() {
    window.requestAnimationFrame(() => {
      if (this.destroyed) return;
      const investigation = this.artworkHotspots?.querySelector('button:not(:disabled)')
        || this.sceneHotspots?.querySelector('.axis-trial-two__investigation-hotspot:not(:disabled)');
      const firstControl = investigation || this.sceneHotspots?.querySelector('button:not(:disabled)');
      firstControl?.focus({ preventScroll: true });
    });
  }

  nextFrame() {
    return new Promise((resolve) => {
      window.requestAnimationFrame(() => window.requestAnimationFrame(resolve));
    });
  }

  delay(duration) {
    return new Promise((resolve) => {
      let timer = null;
      const finish = () => {
        if (timer !== null) window.clearTimeout(timer);
        this.pendingWaits.delete(finish);
        resolve();
      };
      timer = window.setTimeout(finish, duration);
      this.pendingWaits.add(finish);
    });
  }

  waitForTransition(element, propertyName, fallbackDuration) {
    if (!element) return Promise.resolve();

    return new Promise((resolve) => {
      let timer = null;
      const finish = () => {
        element.removeEventListener('transitionend', handleTransitionEnd);
        if (timer !== null) window.clearTimeout(timer);
        this.pendingWaits.delete(finish);
        resolve();
      };
      const handleTransitionEnd = (event) => {
        if (event.target === element && event.propertyName === propertyName) finish();
      };

      element.addEventListener('transitionend', handleTransitionEnd);
      timer = window.setTimeout(finish, fallbackDuration);
      this.pendingWaits.add(finish);
    });
  }

  destroy() {
    if (this.destroyed) return;

    this.destroyed = true;
    this.abortController.abort();
    this.resizeObserver?.disconnect();
    this.descentSmoke?.pause();
    this.finaleVideo?.pause();
    this.ambientVideos.forEach((video) => video.pause());
    if (this.sampleTimer !== null) window.clearTimeout(this.sampleTimer);
    this.pendingWaits.forEach((finish) => finish());
    this.pendingWaits.clear();
    this.root.axisMundiTrialTwo = null;
  }
}

function initAxisMundiTrialTwo(container = document) {
  container.querySelectorAll('[data-axis-trial-two]').forEach((root) => {
    if (root.axisMundiTrialTwo) return;
    root.axisMundiTrialTwo = new AxisMundiTrialTwo(root);
  });
}

function destroyAxisMundiTrialTwo(container) {
  container.querySelectorAll('[data-axis-trial-two]').forEach((root) => {
    root.axisMundiTrialTwo?.destroy();
  });
}

const trialTwoModule = {
  init: initAxisMundiTrialTwo,
  destroy: destroyAxisMundiTrialTwo,
};

window[MODULE_KEY] = trialTwoModule;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAxisMundiTrialTwo());
} else {
  initAxisMundiTrialTwo();
}

document.addEventListener('shopify:section:load', (event) => initAxisMundiTrialTwo(event.target));
document.addEventListener('shopify:section:unload', (event) => destroyAxisMundiTrialTwo(event.target));
})();
